import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
export default (function (props, _ref) {
  var $f7 = _ref.$f7,
      $f7router = _ref.$f7router,
      $ = _ref.$,
      $on = _ref.$on,
      $update = _ref.$update;
  var user = {
    data: {}
  },
      hesitates = user.data.hesitates || [],
      swipeoutInProgress;
  var parent = {
    data: {
      childrens: []
    }
  };
  var types = {
    tamp: lng.tamp,
    vacc: lng.vac,
    analysis: lng.analysis,
    pressure: lng.analysis
  };
  var avatar;
  $on('pageBeforeIn', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var id;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (myApp.children) {
              _context2.next = 16;
              break;
            }

            _context2.next = 3;
            return myApp.user();

          case 3:
            parent = _context2.sent;

            if (!(parent.data.childrens && parent.data.childrens.length === 1)) {
              _context2.next = 13;
              break;
            }

            id = parent.data.childrens[0].id;
            myApp.children = id;
            _context2.next = 9;
            return myApp.getChildren();

          case 9:
            user = _context2.sent;
            avatar = user.avatar || user.data.avatar || 'static/pet.svg';
            _context2.next = 14;
            break;

          case 13:
            if (parent.data.childrens && parent.data.childrens.length > 1) {
              $f7.popup.open('.popup-select-pet');
            } else {
              // apre pagina children
              $f7.dialog.alert(lng.select_pet_message, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        $f7router.navigate('/children/_new/');

                      case 1:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              })));
            }

          case 14:
            _context2.next = 26;
            break;

          case 16:
            _context2.prev = 16;
            _context2.next = 19;
            return myApp.getChildren();

          case 19:
            user = _context2.sent;
            avatar = user.avatar || user.data.avatar || 'static/pet.svg';
            _context2.next = 26;
            break;

          case 23:
            _context2.prev = 23;
            _context2.t0 = _context2["catch"](16);
            console.log('User inesistente. Porto alla pagina /services/');

          case 26:
            hesitates = user.data.hesitates || [];
            $update();
            console.log(hesitates);

          case 29:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[16, 23]]);
  })));

  var selectPET = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(evt) {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              myApp.children = evt.target.dataset.id;
              _context3.next = 3;
              return myApp.getChildren();

            case 3:
              user = _context3.sent;
              avatar = user.avatar || user.data.avatar || 'static/pet.svg';
              hesitates = user.data.hesitates || [];
              $update();
              $f7.popup.close();

            case 8:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function selectPET(_x) {
      return _ref4.apply(this, arguments);
    };
  }();

  var swipeoutOpen = function swipeoutOpen() {
    swipeoutInProgress = true;
  };

  var swipeoutClosed = function swipeoutClosed() {
    swipeoutInProgress = false;
  };

  var goto = function goto(ev) {
    if (swipeoutInProgress) return;
    var url,
        el = $(ev.target);

    while (!(url = el.data('url'))) {
      el = el.parent();
    }

    $f7router.navigate(url);
  };

  var deleteItem = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(ev) {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              $f7.preloader.show();
              _context4.next = 4;
              return myApp.server.deleteJSON('user/me/hesitate/' + $(ev.target).data('item') + '?children=' + (myApp.children || ''));

            case 4:
              user.data.hesitates = _context4.sent;
              _context4.next = 7;
              return myApp.children;

            case 7:
              if (!_context4.sent) {
                _context4.next = 11;
                break;
              }

              myApp.setChildren(user);
              _context4.next = 12;
              break;

            case 11:
              myApp.user(user);

            case 12:
              _context4.next = 17;
              break;

            case 14:
              _context4.prev = 14;
              _context4.t0 = _context4["catch"](0);
              $f7.toastError(_context4.t0);

            case 17:
              _context4.prev = 17;
              $f7.preloader.hide();
              return _context4.finish(17);

            case 20:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 14, 17, 20]]);
    }));

    return function deleteItem(_x2) {
      return _ref5.apply(this, arguments);
    };
  }();

  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page" data-name="hesitates">
    <!-- Top Navbar -->
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner">
        <div class="left">
          <a href="/services/" class="link">
            <i class="f7-icons ios-only">arrow_left</i>
            <i class="material-icons md-only">arrow_back</i>
          </a>
        </div>
        <div class="title">
          <div class="display-flex align-items-center">
            <div class="avatar-small margin-left-half" 
                 style="background-image: url(${avatar})"></div>
            <div class="padding-left">${user.name}</div>
          </div>
        </div>
        <div class="right">
          <a href="/hesitate/_new/" class="link icon-only navbar-tooltip">
            <i class="icon f7-icons if-not-md">plus</i>
            <i class="icon material-icons if-md">add</i>
          </a>
        </div>
      </div>
    </div>
    <!-- Scrollable page content-->
    <div class="page-content bg-color-white hide-navbar-on-scroll unselectable">
      ${hesitates.length > 0 ? $h`
      <div class="bg-color-black text-color-white text-align-center padding-horizontal padding-vertical-half">
        ${lng.hesitates_plus_message}
      </div>
      <div class="list mt-0">
        <ul>
          ${hesitates.sort( (a, b) => a.date > b.date ? -1 : 1 ).map( (item) => $h`  

          <li class="swipeout" data-item='${item.id}'
              @swipeout:open=${swipeoutOpen} 
              @swipeout:closed=${swipeoutClosed} 
              @swipeout:deleted=${deleteItem}
              >
            <div class="swipeout-content">
              <a href="#" @click=${goto} data-url="/hesitate/${item.id}/" class="item-link item-content">
                <div class="item-media">
                  <div class="icon-${
                         item.type
                       }"></div>
                </div>
                <div class="item-inner">
                  <div class="item-title">
                    ${ item.type == 'vacc' ? item.vacctype || 'Vaccino' : item.type == 'tratment' ? item.trattype : item.type == 'pressure' ? lng.analysis_type_7 : item.analysistype} 
                    <div class="item-footer">${new Date(item.date).toLocaleDateString()}</div>
                  </div> 
                  <div class="item-after">${types[item.type]}</div>
                </div>
              </a>
            </div>
            <div class="swipeout-actions-right">
              <a href="#" data-confirm="${lng.delete_item_message}"
                 class="swipeout-delete swipeout-overswipe">
                <i class="icon f7-icons if-not-md">trash</i>
                <i class="icon material-icons if-md">delete</i>
              </a>
            </div>
          </li>
          `)}
        </ul>
      </div>
      ` : $h`
      <div class="display-flex flex-direction-column justify-content-center align-items-center h-90">
        <img width="150" src="static/notfound.svg"/>
        <h3>${lng.hesitates_empty_message}.</h3>

        <div class="block text-align-center">
          <p>
            ${lng.hesitates_empty_message_info}
          </p>
          <p>
            ${lng.hesitates_plus_message}
          </p>
        </div>
      </div>
      `}

    </div>


    <div class="popup popup-select-pet">
      <div class="view">
        <div class="page">
          <div class="navbar">
            <div class="navbar-bg"></div>
            <div class="navbar-inner">
              <div class="title">${lng.select} PET</div>
            </div>
          </div>
          <div class="page-content bg-color-white">
            <div class="list no-hairlines">
              <ul id="popup-select-user-ul">
                ${parent.data.childrens.map((item) => $h`
                <li>
                  <a href="#" @click=${selectPET} data-id='${item.id}' class="item-link item-content">
                    <div class="item-media" data-id='${item.id}'><img data-id='${item.id}' class="avatar-list" src="${item.avatar||'static/pet.svg'}"/></div>
                    <div class="item-inner" data-id='${item.id}'>
                      <div class="item-title" data-id='${item.id}'>${item.name} ${item.lastname}</div>
                      <div class="item-after" data-id='${item.id}'>${myApp.children == item.id ? $h`<i data-id='${item.id}' class="f7-icons text-color-secondary">checkmark_alt</i>` : ''}</div>
                    </div>
                  </a>
                </li>
                `)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>
`
    }
    ;
});